export default __webpack_public_path__ + "static/bncff-web-site-4-mobile-f0566aec3583ac0f232afca931d247e1.jpg";